import { COUNTRY_OPTIONS } from "@mimber/shared"
import { FieldValues, FieldPath } from "react-hook-form"
import { SelectField } from "../SelectField"
import type { CountryFieldProps } from "./CountryField.types"

/**
 * CountryField wraps SelectField with a fixed dropdown of countries
 * (ISO 3166-1 alpha-2 code as the value).
 */
export function CountryField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  placeholder = "Select a country",
  disabled,
  size,
  loading,
  allowClear = true,
}: CountryFieldProps<TFieldValues, TName>) {
  return (
    <SelectField
      name={name}
      control={control}
      label={label}
      required={required}
      help={help}
      options={COUNTRY_OPTIONS}
      placeholder={placeholder}
      disabled={disabled}
      size={size}
      loading={loading}
      showSearch
      filterOption={(input, option) =>
        (option?.label?.toString() ?? "")
          .toLowerCase()
          .includes(input.toLowerCase()) ||
        (option?.value?.toString() ?? "")
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      allowClear={allowClear}
    />
  )
}
